import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

export const useOrgGoalsQueryOptions = (startDate: string, endDate: string) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: ["orgGoals", startDate, endDate, marketPlace],
    queryFn: async () => {
      return await apiClient.getOrgGoals({
        queries: { start_date: startDate, end_date: endDate, market_place: marketPlace },
      });
    },
  });
};
